export default __webpack_public_path__ + "static/media/electric-car.34116cd0.png";